import styled from "styled-components";
import { Alert } from "antd";

export const NoticeContainer = styled(Alert)`
  border-radius: 0px;
  border: none;
  border-left: 6px solid ${props => props.theme.colors.info};
  background-color: ${props => props.theme.backgroundColor.cardDark}!important;
  &.ant-alert.ant-alert-no-icon {
    padding: 25px 30px 25px 25px;
    @media only screen and (max-width: 576px) {
      padding: 15px 10px 20px;
    }
  }
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    border-top: 6px solid ${props => props.theme.colors.info};
    border-left: none;
  }
`;
